/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { DataSetSetupValueDto } from './DataSetSetupValueDto';
import {
    DataSetSetupValueDtoFromJSON,
    DataSetSetupValueDtoFromJSONTyped,
    DataSetSetupValueDtoToJSON,
} from './DataSetSetupValueDto';
import type { MedicalSystemCatalogDto } from './MedicalSystemCatalogDto';
import {
    MedicalSystemCatalogDtoFromJSON,
    MedicalSystemCatalogDtoFromJSONTyped,
    MedicalSystemCatalogDtoToJSON,
} from './MedicalSystemCatalogDto';
import type { NumericDataPointDto } from './NumericDataPointDto';
import {
    NumericDataPointDtoFromJSON,
    NumericDataPointDtoFromJSONTyped,
    NumericDataPointDtoToJSON,
} from './NumericDataPointDto';
import type { NumericDataSetDtoStatistics } from './NumericDataSetDtoStatistics';
import {
    NumericDataSetDtoStatisticsFromJSON,
    NumericDataSetDtoStatisticsFromJSONTyped,
    NumericDataSetDtoStatisticsToJSON,
} from './NumericDataSetDtoStatistics';
import type { NumericEvaluationParameterDto } from './NumericEvaluationParameterDto';
import {
    NumericEvaluationParameterDtoFromJSON,
    NumericEvaluationParameterDtoFromJSONTyped,
    NumericEvaluationParameterDtoToJSON,
} from './NumericEvaluationParameterDto';
import type { QaEquipmentItemGroupDto } from './QaEquipmentItemGroupDto';
import {
    QaEquipmentItemGroupDtoFromJSON,
    QaEquipmentItemGroupDtoFromJSONTyped,
    QaEquipmentItemGroupDtoToJSON,
} from './QaEquipmentItemGroupDto';
import type { TaskTypeDescription } from './TaskTypeDescription';
import {
    TaskTypeDescriptionFromJSON,
    TaskTypeDescriptionFromJSONTyped,
    TaskTypeDescriptionToJSON,
} from './TaskTypeDescription';

/**
 * 
 * @export
 * @interface NumericDataSetDto
 */
export interface NumericDataSetDto {
    /**
     * 
     * @type {string}
     * @memberof NumericDataSetDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof NumericDataSetDto
     */
    combinationHash: string;
    /**
     * 
     * @type {number}
     * @memberof NumericDataSetDto
     */
    numberOfResults: number;
    /**
     * 
     * @type {TaskTypeDescription}
     * @memberof NumericDataSetDto
     */
    taskType: TaskTypeDescription;
    /**
     * 
     * @type {string}
     * @memberof NumericDataSetDto
     */
    jobName: string;
    /**
     * 
     * @type {string}
     * @memberof NumericDataSetDto
     */
    jobConfigurationIuid: string;
    /**
     * 
     * @type {string}
     * @memberof NumericDataSetDto
     */
    taskName: string;
    /**
     * 
     * @type {MedicalSystemCatalogDto}
     * @memberof NumericDataSetDto
     */
    targetSystem: MedicalSystemCatalogDto;
    /**
     * 
     * @type {Array<QaEquipmentItemGroupDto>}
     * @memberof NumericDataSetDto
     */
    supportSystems: Array<QaEquipmentItemGroupDto>;
    /**
     * 
     * @type {Array<DataSetSetupValueDto>}
     * @memberof NumericDataSetDto
     */
    targetSystemSetups: Array<DataSetSetupValueDto>;
    /**
     * 
     * @type {Array<DataSetSetupValueDto>}
     * @memberof NumericDataSetDto
     */
    supportSystemSetups: Array<DataSetSetupValueDto>;
    /**
     * 
     * @type {NumericEvaluationParameterDto}
     * @memberof NumericDataSetDto
     */
    evaluationParameter: NumericEvaluationParameterDto;
    /**
     * 
     * @type {Array<NumericDataPointDto>}
     * @memberof NumericDataSetDto
     */
    data: Array<NumericDataPointDto>;
    /**
     * 
     * @type {NumericDataSetDtoStatistics}
     * @memberof NumericDataSetDto
     */
    statistics?: NumericDataSetDtoStatistics | null;
    /**
     * 
     * @type {string}
     * @memberof NumericDataSetDto
     */
    $type?: NumericDataSetDtoTypeEnum;
}


/**
 * @export
 */
export const NumericDataSetDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedResultsDtoNumericDataSetDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Results.Dto.NumericDataSetDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type NumericDataSetDtoTypeEnum = typeof NumericDataSetDtoTypeEnum[keyof typeof NumericDataSetDtoTypeEnum];


/**
 * Check if a given object implements the NumericDataSetDto interface.
 */
export function instanceOfNumericDataSetDto(value?: unknown): value is NumericDataSetDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(NumericDataSetDtoTypeEnum)[0];
}

export function NumericDataSetDtoFromJSON(json: any): NumericDataSetDto {
    return NumericDataSetDtoFromJSONTyped(json, false);
}

export function NumericDataSetDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NumericDataSetDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'combinationHash': json['combinationHash'],
        'numberOfResults': json['numberOfResults'],
        'taskType': TaskTypeDescriptionFromJSON(json['taskType']),
        'jobName': json['jobName'],
        'jobConfigurationIuid': json['jobConfigurationIuid'],
        'taskName': json['taskName'],
        'targetSystem': MedicalSystemCatalogDtoFromJSON(json['targetSystem']),
        'supportSystems': ((json['supportSystems'] as Array<any>).map(QaEquipmentItemGroupDtoFromJSON)),
        'targetSystemSetups': ((json['targetSystemSetups'] as Array<any>).map(DataSetSetupValueDtoFromJSON)),
        'supportSystemSetups': ((json['supportSystemSetups'] as Array<any>).map(DataSetSetupValueDtoFromJSON)),
        'evaluationParameter': NumericEvaluationParameterDtoFromJSON(json['evaluationParameter']),
        'data': ((json['data'] as Array<any>).map(NumericDataPointDtoFromJSON)),
        'statistics': !exists(json, 'statistics') ? undefined : NumericDataSetDtoStatisticsFromJSON(json['statistics']),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function NumericDataSetDtoToJSON(value?: NumericDataSetDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value.id,
        'combinationHash': value.combinationHash,
        'numberOfResults': value.numberOfResults,
        'taskType': TaskTypeDescriptionToJSON(value.taskType),
        'jobName': value.jobName,
        'jobConfigurationIuid': value.jobConfigurationIuid,
        'taskName': value.taskName,
        'targetSystem': MedicalSystemCatalogDtoToJSON(value.targetSystem),
        'supportSystems': ((value.supportSystems as Array<any>).map(QaEquipmentItemGroupDtoToJSON)),
        'targetSystemSetups': ((value.targetSystemSetups as Array<any>).map(DataSetSetupValueDtoToJSON)),
        'supportSystemSetups': ((value.supportSystemSetups as Array<any>).map(DataSetSetupValueDtoToJSON)),
        'evaluationParameter': NumericEvaluationParameterDtoToJSON(value.evaluationParameter),
        'data': ((value.data as Array<any>).map(NumericDataPointDtoToJSON)),
        'statistics': NumericDataSetDtoStatisticsToJSON(value.statistics),
        '$type': value.$type,
    });
}

